import styled from "@emotion/styled";
import { TableRow } from "@mui/material";

export const StoresSettingsTableHeader = styled.div(() => ({
	marginBottom: 16,
	"& > div": {
		width: "auto"
	}
}));

export const StoreTableRow = styled(TableRow)(({ theme }) => ({
	cursor: "pointer",
	"&:hover": {
		backgroundColor: theme.project.colors.backgroundColors["card:hover"]
	}
}));

export const StoresSettingsTableNoResultsFound = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	gap: 16,
	marginTop: 16,
	h1: {
		...theme.project.typography.heading.h6,
		margin: 0
	},
	"div:nth-of-type(1)": {
		...theme.project.typography.body.body1,
		div: {
			margin: 0
		},
		ul: {
			margin: 0
		}
	},
	"div:nth-of-type(2)": {
		...theme.project.typography.caption
	}
}));
